<template>
  <div class="ad-plan-detail">
    <div class="basic_detail">
      <breadcrumb :breadcrumbList="breadcrumbList"></breadcrumb>
    </div>
    <div class="plan-details-content">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1">
          <span slot="tab">
            <a-badge v-if="planInfo.status == -2" status="warning">
              订单信息&nbsp;
            </a-badge>
            <span v-else>订单信息</span>
          </span>
          <div class="info-panel">
            <div class="panel-header">
              订单信息{{ planInfo.statusName ? '（' + planInfo.statusName + '）' : '' }}
            </div>
            <div class="panel-body">
              <span class="panel-body-name">{{ planInfo.planName }}</span>
              <a-row type="flex" justify="start">
                <a-col :span="6">
                  <ul>
                    <li class="panel-info-item">
                      <em>渠道方：</em>
                      <span>{{ planInfo.channelName }}</span>
                    </li>
                    <li class="panel-info-item advertiserName">
                      <em>广告主：</em>
                      <span>{{ planInfo.advertiserName }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>广告主行业：</em>
                      <span>{{ planInfo.adCategoryName }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>创建者：</em>
                      <span>{{ planInfo.createUserName }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>订单编号：</em>
                      <span>{{ planInfo.planId }}</span>
                    </li>
                  </ul>
                </a-col>
                <a-col :span="5">
                  <ul>
                    <li class="panel-info-item">
                      <em>订单金额：</em>
                      <span>￥{{ planInfo.price | NumberFormat }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>媒体数量：</em>
                      <span>{{ planInfo.pointCount }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>展现机制：</em>
                      <span>{{
                        planInfo.priceStrategy == 1
                          ? '轮播'
                          : planInfo.priceStrategy == 2
                          ? '触发'
                          : '--'
                      }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>结算方式：</em>
                      <span>{{ planInfo.settlementName }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>播放次数：</em>
                      <span>{{ `${planInfo.playCount || 0}次` }}</span>
                    </li>
                  </ul>
                </a-col>
                <a-col :span="5">
                  <ul>
                    <li class="panel-info-item">
                      <em>更新时间：</em>
                      <span>{{ planInfo.updateTime }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>开始时间：</em>
                      <span>{{ planInfo.beginTime }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>结束时间：</em>
                      <span>{{ planInfo.endTime }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>归属人：</em>
                      <span>{{ planInfo.saleName || '' }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>媒体类型：</em>
                      <span>{{ planInfo.mediaTypeName }}</span>
                    </li>
                  </ul>
                </a-col>
                <a-col :span="5">
                  <ul>
                    <li class="panel-info-item">
                      <em>素材类型：</em>
                      <span>{{ planInfo.materialType }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>播放时长：</em>
                      <span>{{ planInfo.playDuration ? planInfo.playDuration + '秒' : '' }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>广告位置：</em>
                      <span>{{ planInfo.positionName }}</span>
                    </li>
                    <li class="panel-info-item">
                      <em>来源：</em>
                      <span>{{
                        planInfo.originCompanyName && planInfo.originUserName
                          ? (planInfo.originCompanyName || '') +
                            '-' +
                            (planInfo.originUserName || '')
                          : ''
                      }}</span>
                    </li>
                    <li class="panel-info-item" v-if="planInfo.priceStrategy == 1">
                      <em>播放时段：</em>
                      <span v-if="planInfo.deliveryPeriod == 1">{{ '普通时段' }}</span>
                      <span v-else-if="planInfo.deliveryPeriod == 2">{{ '黄金时段' }}</span>
                      <span v-else-if="planInfo.deliveryPeriod == 3">{{ '24小时霸屏' }}</span>
                    </li>
                  </ul>
                </a-col>
                <a-col :span="3">
                  <dl class="panel-order-status">
                    <dt>状态</dt>
                    <dd>
                      <a-badge
                        v-if="planInfo.status == -3"
                        status="error"
                        :text="planInfo.statusName"
                      />
                      <a-badge
                        v-else-if="planInfo.status == -2"
                        status="warning"
                        :text="planInfo.statusName"
                      />
                      <a-badge
                        v-else-if="planInfo.status == 2"
                        status="processing"
                        :text="planInfo.statusName"
                      />
                      <a-badge
                        v-else-if="planInfo.status == 3"
                        status="success"
                        :text="planInfo.statusName"
                      />
                      <!-- <a-badge v-else-if="planInfo.status == 6" status="default" :text="planInfo.statusName" />
                      <a-badge v-else-if="planInfo.status == 8" status="default" :text="planInfo.statusName" />
                      <a-badge v-else-if="planInfo.status == 9" status="default" :text="planInfo.statusName" />
                      <a-badge v-else-if="planInfo.status == 10" status="default" :text="planInfo.statusName" /> -->
                      <a-badge v-else status="default" :text="planInfo.statusName" />
                    </dd>
                  </dl>
                </a-col>
              </a-row>
            </div>
            <div class="panel-footer">
              <a-row type="flex" justify="center" :gutter="8">
                <a-col v-for="(item, index) in orderOperateBtnObj" :key="index" class="gutter-row">
                  <a-button @click="item.fun(item.funArg)">{{ item.text }}</a-button>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="2" tab="媒体列表">
          <div class="plan-detail-title">{{ `媒体列表(${sumMedia})` }}</div>
          <div class="plan-detail-table">
            <div class="totalArea_header">
              <div class="info_box">
                <a-icon type="info-circle" />
                <template v-if="planInfo.status === -2"
                  >可接广告
                  <span style="color: #1890ff">{{
                    planMachineCountInfo.canReleaseCount || 0
                  }}</span>
                  台， 不接广告
                  <span style="color: #ff4d4f">{{
                    planMachineCountInfo.cannotReleaseCount || 0
                  }}</span>
                  台，</template
                >
                设备在线
                <span style="color: #1890ff">{{ planMachineCountInfo.onlineCount || 0 }}</span>
                台， 设备离线
                <span style="color: #ff4d4f">{{ planMachineCountInfo.offLineCount || 0 }}</span>
                台， 离线超时
                <span style="color: #ff4d4f">{{ planMachineCountInfo.abnormalCount || 0 }}</span>
                台，
                <span
                  v-if="
                    planInfo.status === 2 &&
                      (userInfo.userType === 1 ||
                        userInfo.userType === 5 ||
                        userInfo.userType === 6)
                  "
                  class="explain-modal"
                  @click="editPlanMedia"
                  >调整点位</span
                >
                <span class="import_excel" @click="exportPoint">导出明细</span>
              </div>
            </div>
            <addPlanDetailSelect @callback="getAllSendList" ref="addPlanDetailSelect" />
            <a-spin tip="Loading..." :spinning="tableLoading">
              <a-table
                :columns="totalAreaColumns"
                :dataSource="totalAreaList"
                :scroll="{ x: 1800 }"
                class="totalArea_table"
                :pagination="false"
                @change="columnsFilter"
              >
                <div
                  slot="filterDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                  class="custom-filter-dropdown"
                >
                  <a-input
                    :placeholder="`搜索${column.title}`"
                    :value="selectedKeys[0]"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm)"
                    style="width: 188px; margin-bottom: 8px; display: block"
                  />
                  <a-button
                    type="primary"
                    @click="() => handleSearch(selectedKeys, confirm)"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    >搜索
                  </a-button>
                  <a-button
                    @click="() => handleReset(clearFilters)"
                    size="small"
                    style="width: 90px"
                    >重置
                  </a-button>
                </div>
                <a-icon
                  slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }"
                />
                <template slot="onlineStatus" slot-scope="onlineStatus">
                  <p>
                    <span v-if="onlineStatus == '1'">
                      <a-badge status="success" />
                      <span>设备在线</span>
                    </span>
                    <span v-else-if="onlineStatus == '0'">
                      <a-badge status="warning" />
                      <span>设备离线</span>
                    </span>
                    <span v-else-if="onlineStatus == '2'">
                      <a-badge status="error" />
                      <span>离线超时</span>
                    </span>
                    <span v-else>
                      <span>--</span>
                    </span>
                  </p>
                </template>
                <template slot="canRelease" slot-scope="canRelease">
                  <p>
                    <span v-if="canRelease == true">
                      <a-badge status="processing" />
                      <span>可接广告</span>
                    </span>
                    <span v-else-if="canRelease == false">
                      <a-badge status="default" />
                      <span>不接广告</span>
                    </span>
                    <span v-else>
                      <span>--</span>
                    </span>
                  </p>
                </template>
              </a-table>
            </a-spin>

            <div style="text-align: right; margin-top: 16px">
              <a-pagination
                :showTotal="total => `共 ${total} 条`"
                :pageSizeOptions="pageSizeOptions"
                :total="totalAreaPageInfo.total"
                showSizeChanger
                showQuickJumper
                :pageSize="totalAreaPageInfo.pageSize"
                v-model="totalAreaPageInfo.current"
                @showSizeChange="totalAreaChangeSize"
                @change="totalAreaChangePage"
              ></a-pagination>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="3">
          <span slot="tab">
            <a-badge v-if="materialStatus.status == 2" status="warning">
              素材信息&nbsp;
            </a-badge>
            <span v-else>素材信息</span>
          </span>
          <div class="info-panel">
            <div class="panel-header">
              素材信息{{ materialStatus.statusName ? '（' + materialStatus.statusName + '）' : '' }}
            </div>
            <div class="panel-body">
              <div class="switch_btn_wrapper">
                <a-radio-group v-model="materialRadioValue" @change="onChangeMaterialRadioValue">
                  <a-radio-button value="1">
                    广告素材
                  </a-radio-button>
                  <a-radio-button value="2">
                    资质材料
                  </a-radio-button>
                </a-radio-group>
              </div>

              <a-alert
                class="alert_class"
                v-show="
                  planInfo.createUserId == userInfo.userId &&
                    ![-999, -3, 6, 8, 9, 10].includes(planInfo.status)
                "
                message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！"
                type="warning"
                show-icon
              />

              <div class="content_warpper">
                <material-frames
                  v-show="materialRadioValue == '1'"
                  :isEdit="isEdit"
                  :isDuration="Number(planInfo.playDuration)"
                  :beginTime="planInfo.beginTime"
                  :endTime="planInfo.endTime"
                  :planId="planInfo.planId"
                  :materialSize="materialSize"
                  :priceStrategy="planInfo.priceStrategy"
                  :isExistH5Audit="isExistH5Audit"
                />

                <div v-show="isShowEditMaterialBtn()" class="">
                  <a-button @click="handlerEditMaterial" type="primary">
                    编辑素材
                  </a-button>
                </div>

                <div v-show="isEdit" class="edit_btn">
                  <a-button
                    v-show="materialRadioValue == '1'"
                    @click="completeEditMaterial"
                    type="primary"
                  >
                    完成
                  </a-button>
                  <a-button v-show="materialRadioValue == '1'" @click="cancelEditMaterial">
                    取消
                  </a-button>
                </div>

                <div class="body-right" v-show="materialRadioValue == '2'">
                  <div class="content-bar">资质材料</div>
                  <div class="qualification_warp">
                    <div class="thumbnail-list">
                      <img
                        alt=""
                        v-for="(item, index) in certificationList"
                        :key="index"
                        :src="item"
                        @click="setActiveQuaImg(item, index)"
                        class="thumbnail-item"
                        :class="{ 'active-border': activeQuaIndex == index }"
                      />
                    </div>
                    <div class="qualification-info">
                      <header>
                        <span v-if="certificationList.length > 0">{{
                          `第 ${activeQuaIndex + 1} 张（共${certificationList.length}张）`
                        }}</span>
                      </header>
                      <div class="qualification-wrap">
                        <a-empty
                          v-if="!activeQuaImg"
                          :description="false"
                          style="margin-top: 105px"
                        ></a-empty>
                        <img
                          v-else
                          alt=""
                          :src="activeQuaImg"
                          class="qualification-item"
                          @click="previewMaterial(1, activeQuaImg)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="panel-footer">
              <a-row type="flex" justify="center" :gutter="8">
                <a-col
                  v-for="(item, index) in materialOperateBtnObj"
                  :key="index"
                  class="gutter-row"
                >
                  <a-button @click="item.fun(item.funArg)">{{ item.text }}</a-button>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="4" tab="数据报告" force-render>
          <planDetailCharts :planInfo="planInfo" :countPlanPointInfo="planMachineCountInfo" />
        </a-tab-pane>
      </a-tabs>
    </div>
    <!--投放中更换设备-->
    <edit-pulling-plan-media
      :editMediaClick="editMediaClick"
      @closeEidtMedia="editMediaClick = false"
    ></edit-pulling-plan-media>
    <!--投放中更换物料及历史-->
    <edit-pulling-plan-material
      :changeMaterialList="changeMaterialList"
      :showHistory="showHistory"
      :playDuration="planInfo.playDuration || 0"
      :adMaterialList="adMaterialList"
      :planInfo="planInfo"
      @getMaterialInfo="getMaterialInfo"
    ></edit-pulling-plan-material>
    <!--查看大图-->
    <a-modal
      v-model="previewImgModal"
      :title="previewImgModalTitle"
      :footer="null"
      :zIndex="1002"
      :closable="false"
      :bodyStyle="{ padding: 0, margin: 0, background: 'rgba(0, 0, 0, 0)' }"
      width="390px"
      class="preview-img"
    >
      <div class="img-box">
        <img :src="previewUrl" alt />
      </div>
    </a-modal>
    <!--查看视频-->
    <a-modal
      v-model="previewVideoModal"
      @cancel="handleCancel"
      :footer="null"
      :closable="false"
      :bodyStyle="{ padding: 0, margin: 0, background: 'rgba(0, 0, 0, 0)' }"
      :zIndex="1002"
      width="370px"
      class="preview-video"
    >
      <div class="video-box">
        <video
          ref="showMaterialVideo"
          :src="previewUrl"
          controls
          autoplay="autoplay"
          loop="loop"
        ></video>
      </div>
    </a-modal>
    <!--计划、素材审批意见-->
    <a-modal
      :title="auditMaterialTitle"
      v-model="auditMaterialModal"
      :confirm-loading="btnLoading"
      @ok="auditMaterial"
      okText="确认"
      cancelText="取消"
      :afterClose="clearAuditMaterialText"
    >
      <a-alert
        class="alert_class"
        message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！"
        type="warning"
        show-icon
      />
      <a-textarea
        v-model="auditMaterialText"
        :autoSize="{ minRows: 4, maxRows: 6 }"
        style="marginTop:10px"
      />
    </a-modal>
    <!--填写备案意见-->
    <a-modal
      :title="auditTitle"
      v-model="auditModal"
      :confirm-loading="btnLoading"
      @ok="pullPlanAuditMaterial"
      okText="确认"
      cancelText="取消"
      :afterClose="clearValue"
    >
      <a-textarea v-model="auditText" :autoSize="{ minRows: 4, maxRows: 6 }" />
    </a-modal>
    <!--投放点位-查看全部-->

    <!--投放区域对话框-->

    <!--监播报告-->
    <a-modal class="report-model" width="928px" title="监播报告" v-model="reportModel">
      <a-radio-group
        buttonStyle="solid"
        v-model="reportType"
        @change="showReport"
        style="margin-bottom: 32px"
      >
        <a-radio-button value="1">上刊报告</a-radio-button>
        <a-radio-button value="2">下刊报告</a-radio-button>
        <a-radio-button value="3">换画报告</a-radio-button>
      </a-radio-group>
      <div style="position: relative" :style="{ paddingBottom: reportTotal > 6 ? '32px' : '0' }">
        <div v-if="reportList.length == 0">
          <img
            src="../../assets/images/no-play-list.png"
            alt
            style="margin-bottom: 12px; width: 117px"
          />
          <p style="color: #b7b9be" v-if="reportType == 1">暂无上刊报告</p>
          <p style="color: #b7b9be" v-if="reportType == 2">暂无下刊报告</p>
          <p style="color: #b7b9be" v-if="reportType == 3">暂无换画报告</p>
          <a
            v-if="
              /^(1|2)$/.test(reportType) &&
                !generateReportArr.includes(reportType) &&
                planInfo.status === 2
            "
            @click="generateReport(reportType)"
            >立即生成</a
          >
          <span
            v-else-if="
              /^(1|2)$/.test(reportType) &&
                generateReportArr.includes(reportType) &&
                planInfo.status === 2
            "
            >生成中</span
          >
        </div>
        <div v-else>
          <div
            class="cards-wrap"
            :style="{
              justifyContent: reportTotal == 1 ? 'center' : 'space-between'
            }"
          >
            <div class="card" v-for="(item, index) in reportList" :key="index">
              <div class="card-top">
                <img class="card-img" :src="item.materialImg" alt />
                <div class="card-time">
                  {{ item.updateTime }}
                  <div>
                    <span>更新</span>
                  </div>
                </div>
                <div class="card-count">
                  <span>计划：{{ item.planCount }}个</span>
                  <span>|</span>
                  <span v-if="reportType == 1">上刊：{{ item.realCount }}个</span>
                  <span v-if="reportType == 2">下刊：{{ item.realCount }}个</span>
                  <span v-if="reportType == 3">换画：{{ item.realCount }}个</span>
                </div>
              </div>
              <div class="card-bottom">
                <div @click="updateReport(item)"><a-icon type="sync" />更新</div>
                <div @click="downloadReport(item)"><a-icon type="download" />下载</div>
              </div>
            </div>
          </div>
          <a-pagination
            v-if="reportTotal > 6"
            class="report-page"
            v-model="reportPage"
            :total="reportTotal"
            :pageSize="6"
            @change="changeReportPage"
          />
        </div>
      </div>
      <template slot="footer">
        <a-button @click="reportModel = false">关闭</a-button>
      </template>
    </a-modal>

    <failModal :failModalStatus="failModalStatus" :datalist="totalAreaList" ref="failModal" />

    <!-- 素材审核-弹框组件 -->
    <MaterialAuditModal ref="materialAuditModalRef" />

    <!-- 素材审核记录-弹框组件 -->
    <MaterialAuditRecordModal ref="materialAuditRecordModalRef" />
  </div>
</template>

<script>
import breadcrumb from '../common/Breadcrumb.vue'
import editPullingPlanMaterial from '../common/editPullingPlanMaterial'
import editPullingPlanMedia from '../common/editPullingPlanMedia'
import api from '../../commomFun/api.js'
import moment from 'moment'
import timeFormat from '../../commomFun/timeFormat'
import planDetailCharts from './planDetailCharts'
import failModal from './failModal'
import addPlanDetailSelect from './addPlanDetailSelect'
import materialFrames from './materialFrames/index'
import { mapMutations, mapState } from 'vuex'
import { materialSize } from '../../utils/config'
import { getplayDates, getDiffList } from '../../utils/utils'
import * as materialApi from '@/api/material.api'
import MaterialAuditModal from '@/components/common/materialAuditModal/index.vue'
import MaterialAuditRecordModal from '@/components/common/materialAuditRecordModal/index.vue'

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export default {
  name: 'channelAdPlanDetail',
  components: {
    breadcrumb,
    editPullingPlanMaterial,
    editPullingPlanMedia,
    planDetailCharts,
    failModal,
    addPlanDetailSelect,
    materialFrames,
    MaterialAuditModal,
    MaterialAuditRecordModal
  },
  inject: ['reload'],
  data() {
    return {
      // 点位下发统计信息
      planMachineCountInfo: {},
      generateReportArr: [],
      clickPublishStatus: false, // 判断是否已经点击截屏
      failModalStatus: false,
      userInfo: {},
      planId: '',
      tableLoading: false,
      // 面包屑
      breadcrumbList: [
        {
          name: '投放管理',
          path: '/channelAdPlan'
        },
        {
          name: '广告订单',
          path: ''
        },
        {
          name: '计划详情',
          path: ''
        }
      ],
      sumMedia: 0,
      planInfo: {},
      materialModal: false,
      previewImgModal: false,
      previewImgModalTitle: '',
      previewVideoModal: false,
      previewUrl: '',
      //上传
      // header: {
      //   token: '',
      //   uid: ''
      // },
      uploadInfo: {
        playForm: '全屏',
        playDuration: '5'
      },
      uploadMaterialModal: false,
      fullImgLoading: false,
      // uploadMaterialImgUrl: config.uploadMaterialImgUrl,
      uploadMLoading: false,
      // 是否需要填写理由
      isAuditPlan: false,
      auditModal: false,
      auditType: '', //通过或不通过
      auditText: '',
      auditTitle: '',
      btnLoading: false,
      auditMaterialTitle: '',
      auditMaterialModal: false,
      auditMaterialText: '',
      auditMaterialType: '',
      // 分页
      pageSizeOptions: ['5', '10', '20', '30', '40', '100', '200', '500'],
      // 查看全部-投放区域弹出框
      isTotalAreaModal: false,
      // 全部投放设备筛选条件
      deviceFilterInfo: {
        communityName: null,
        status: null,
        deviceModel: null,
        deviceName: null,
        areaName: null,
        onlineStatus: null,
        watchMode: null,
        sortField: null,
        sortMode: null
      },
      devStatus: '',
      totalAreaList: [],
      totalAreaColumns: [
        {
          title: '终端型号',
          key: 'modelType',
          dataIndex: 'modelType',
          align: 'left',
          width: 132,
          ellipsis: true,
          filters: [
            { text: 'QLG19-C215', value: '7' },
            { text: 'GWS19-49', value: '12' },
            { text: 'QLL19-C32', value: '13' },
            { text: 'QLG19-215', value: '14' },
            { text: 'QLL19-32', value: '15' },
            { text: 'QLG2020-R8', value: '17' }
          ],
          filterMultiple: false
        },
        {
          title: '监播方式',
          key: 'watchMode',
          dataIndex: 'watchMode',
          align: 'left',
          width: 132,
          ellipsis: true,
          filters: [{ text: '人工拍照', value: '2' }, { text: '程序截屏', value: '1' }],
          filterMultiple: true
        },
        {
          title: '点位名称',
          key: 'deviceName',
          dataIndex: 'deviceName',
          align: 'left',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          }
        },
        {
          title: '所属城市',
          dataIndex: 'city',
          width: 200,
          align: 'left',
          ellipsis: true,
          customRender: (text, record, index) => {
            return record.province + record.city || '--'
          },
          scopedSlots: {}
        },
        {
          title: '区县',
          key: 'areaString',
          dataIndex: 'areaString',
          width: 150,
          align: 'left',
          ellipsis: true
        },
        {
          title: '网点资源',
          key: 'communityName',
          dataIndex: 'communityName',
          ellipsis: true,
          width: 180,
          align: 'left',
          scopedSlots: {
            customRender: 'communityName',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          }
        },
        {
          title: '点位ID',
          // title: '媒体编号',
          key: 'deviceCode',
          dataIndex: 'deviceCode',
          align: 'left',
          width: 190,
          ellipsis: true,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          }
        },
        {
          title: 'MAC',
          key: 'mac',
          align: 'left',
          dataIndex: 'mac',
          width: 190,
          ellipsis: true,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          }
        },
        {
          title: '所属公司',
          key: 'companyName',
          dataIndex: 'companyName',
          align: 'left',
          width: 190,
          ellipsis: true,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          }
        },
        {
          title: '连续在线',
          key: 'onlineDayNum',
          dataIndex: 'onlineDayNum',
          width: 150,
          align: 'left',
          ellipsis: true,
          sorter: true
        },
        {
          title: '网络状态',
          dataIndex: 'onlineStatus',
          align: 'left',
          fixed: 'right',
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: 'onlineStatus' }
        },
        {
          title: '是否可接广告',
          key: 'canRelease',
          dataIndex: 'canRelease',
          align: 'left',
          fixed: 'right',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'canRelease' }
        },
        {
          title: '原因',
          key: 'rejectReason',
          dataIndex: 'rejectReason',
          width: 100,
          align: 'left',
          fixed: 'right',
          ellipsis: true
        }
      ],
      totalAreaPageInfo: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      // 搜索媒体名称
      mediaName: '',
      // 当前操作计划的版本号
      version: '',
      // 所有设备类型信息
      deviceModelList: [],
      playDuration: 0,
      // 上传物料
      modelMaterials: [],
      // 当前选中的机型
      activeModelType: 7,
      activeIndex: 0,
      // 当前上传物料的机型下标（解决还在上传中切换了机型导致物料关联错误）
      uploadingModelIndex: 0,
      // 当前选择的机型上传素材
      activeModelMaterial: {
        materialSize: '',
        adSize: '',
        modelID: '',
        model: '',
        isDuration: 10
      },
      // 修改物料
      changeMaterialList: [
        {
          id: '',
          modelID: '',
          model: '',
          adSize: {
            width: '',
            height: ''
          },
          materialSize: {
            width: '',
            height: ''
          },
          isDuration: 10,
          materialId: ''
        },
        {
          modelID: '',
          model: '',
          adSize: {
            width: '',
            height: ''
          },
          materialSize: {
            width: '',
            height: ''
          },
          isDuration: 10,
          materialId: ''
        }
      ],
      // 增删设备媒体
      editMediaClick: false,
      // 更换物料历史
      showHistory: false,
      // isHaveNewModelMaterial: false,
      // 投放中待审核的物料
      newModelMaterial: [],
      newMaterialList: [],
      status: '',
      //监播报告相关
      reportModel: false,
      reportType: '1',
      reportList: [
        {
          materialImg: '',
          updateTime: '2020-03-06 00:42',
          realCount: 320,
          planCount: 300,
          url: 'ppt地址'
        }
      ],
      reportPage: 1,
      reportTotal: 1,
      // 资质图片列表
      certificationList: [],
      activeQuaImg: '',
      activeQuaIndex: 0,
      materialStatus: {},
      adMaterialList: [],
      imgHover: false,
      materialRadioValue: '1', //广告素材/资质材料 切换
      isEdit: false, //是否编辑物料
      materialSize: {}, //物料尺寸
      materialId: '', //物料id
      priceStrategy: 0, //订单展现机制
      needAudit: false, //订单是否是投放中更换素材，需要审核
      // 是否开启H5审核
      isOpenH5Audit: true,
      // 是否存在待审核记录（H5审核）
      isExistH5Audit: false
    }
  },
  computed: {
    ...mapState([
      'framesList',
      'currentAdMaterialDetail',
      'framesTagColor',
      'totalPlayDateNum',
      'playDateNum',
      'selectDateList',
      'isUpload'
    ]),
    /**
     * planInfo.status: -999-删除  -1-失效，0-新建（未投放），2-投放中，3-审核中 ，4-审核未通过 6-投放完成
     * 
      订单待确认 订单待投放 订单投放中 订单已暂停 订单已过期 已取消 订单已终止 已完成 订单已拒绝
      订单创建人比订单审核人多‘修改订单’、‘取消订单’
      判断当前是否为创建人
      DELETE(-999,"已删除"), 1
      TO_BE_CONFIRM(-2, "待确认"),
      ACCEPT(1, "接受"),
      RELEASE(2,"投放中"),
      WAIT_RELEASE(3,"待投放"),
      FAIL_AUDIT(4,"审核未通过"),
      REJECT(-3, "拒绝"), 1
      FINISH(6,"已完成"), 1
      PAUSE(7,"暂停"),
      EXPIRE(8,"已过期"), 1
      CANCEL(9,"已取消"), 1
      STOP(10,"已终止"); 1
      */
    orderOperateBtnObj() {
      if (
        this.planInfo &&
        this.planInfo.statusName &&
        this.planInfo.createUserId &&
        this.userInfo.userId
      ) {
        let reviewer = {
          '-2': [
            { text: '接受订单', fun: this.handlePlan, funArg: 'acceptPlan' },
            {
              text: '拒绝订单',
              fun: this.handleMaterial,
              funArg: 'rejectPlan'
            }
          ],
          3: [
            {
              text: '拒绝订单',
              fun: this.handleMaterial,
              funArg: 'rejectPlan'
            }
          ],
          2: [
            { text: '终止订单', fun: this.handlePlan, funArg: 'stopPlan' },
            { text: '暂停订单', fun: this.handlePlan, funArg: 'pausePlan' }
          ],
          7: [
            { text: '继续订单', fun: this.handlePlan, funArg: 'continuePlan' },
            { text: '终止订单', fun: this.handlePlan, funArg: 'stopPlan' }
          ],
          8: [],
          9: [],
          10: [],
          6: [],
          '-3': [{ text: '拒绝理由', fun: this.getReason, funArg: 'plan' }]
        }
        let creator = {
          '-2': [
            { text: '修改订单', fun: this.editPLan, funArg: null },
            { text: '取消订单', fun: this.handlePlan, funArg: 'cancelPlan' }
          ],
          3: [{ text: '取消订单', fun: this.handlePlan, funArg: 'cancelPlan' }],
          2: [
            { text: '终止订单', fun: this.handlePlan, funArg: 'stopPlan' },
            { text: '暂停订单', fun: this.handlePlan, funArg: 'pausePlan' }
          ],
          7: [
            { text: '继续订单', fun: this.handlePlan, funArg: 'continuePlan' },
            { text: '终止订单', fun: this.handlePlan, funArg: 'stopPlan' }
          ],
          8: [{ text: '修改订单', fun: this.editPLan, funArg: null }],
          9: [{ text: '修改订单', fun: this.editPLan, funArg: null }],
          10: [],
          6: [],
          // '-3': [{text: '拒绝理由', fun: this.getReason, funArg: 'plan'}]
          '-3': [
            { text: '修改订单', fun: this.editPLan, funArg: null },
            { text: '取消订单', fun: this.handlePlan, funArg: 'cancelPlan' },
            { text: '拒绝理由', fun: this.getReason, funArg: 'plan' }
          ]
        }
        if (this.planInfo.createUserId == this.userInfo.userId) {
          if (
            this.userInfo.userType === 1 ||
            this.userInfo.userType === 5 ||
            this.userInfo.userType === 4
          ) {
            creator['-2'].unshift(
              { text: '接受订单', fun: this.handlePlan, funArg: 'acceptPlan' },
              {
                text: '拒绝订单',
                fun: this.handleMaterial,
                funArg: 'rejectPlan'
              }
            )
          }
          return creator[this.planInfo.status] || []
        } else if (
          this.userInfo.userType === 1 ||
          this.userInfo.userType === 5 ||
          this.userInfo.userType === 4
        ) {
          return reviewer[this.planInfo.status] || []
        }
      }
      return []
    },
    /**
     * materialStatus.status：
     * -1 "审核不通过";
     * 0 "无效";
     * 1 "备案通过";
     * 2 "待审核";
     * -999 "删除"
     */
    materialOperateBtnObj() {
      // console.log('this.materialStatus.status ====', this.materialStatus.status)
      // console.log('this.planInfo.createUserId ====', this.planInfo.createUserId)
      // console.log('this.userInfo.userId ====', this.userInfo.userId)
      if (this.materialStatus && this.planInfo.createUserId && this.userInfo.userId) {
        let reviewer = {}
        // 如果开启H5审核
        if (this.isOpenH5Audit) {
          // 如果存在待审核记录（H5审核），显示 '撤回审批'
          if (this.isExistH5Audit) {
            reviewer = {
              2: [
                { text: '查看审批', fun: this.viewAudit, funArg: 'y' },
                { text: '撤回审批', fun: this.recallAudit, funArg: 'y' },
                { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
              ],
              1: [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
              '-1': [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
              0: [],
              换画: [
                { text: '查看审批', fun: this.viewAudit, funArg: 'y' },
                { text: '撤回审批', fun: this.recallAudit, funArg: 'y' },
                { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
              ]
            }
          } else {
            // 如果不存在待审核记录（H5审核），显示 '发起审批'
            reviewer = {
              2: [
                { text: '发起审批', fun: this.createAudit, funArg: 'y' },
                { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
              ],
              1: [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
              '-1': [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
              0: [],
              换画: [
                { text: '发起审批', fun: this.createAudit, funArg: 'y' },
                { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
              ]
            }
          }
        } else {
          // 如果关闭H5审核，走旧逻辑
          reviewer = {
            2: [
              { text: '备案通过', fun: this.handleMaterial, funArg: 'y' },
              { text: '备案拒绝', fun: this.handleMaterial, funArg: 'n' }
            ],
            1: [{ text: '备案意见', fun: this.showMaterialAuditRecord, funArg: '' }],
            '-1': [{ text: '备案意见', fun: this.showMaterialAuditRecord, funArg: '' }],
            0: [],
            换画: [
              { text: '备案通过', fun: this.auditPlan, funArg: 'y' },
              { text: '备案拒绝', fun: this.auditPlan, funArg: 'n' }
            ]
          }
        }
        // 判断当前是否为创建人
        let creator = {}
        // 如果开启H5审核
        if (this.isOpenH5Audit) {
          creator = {
            1: [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
            '-1': [{ text: '审批记录', fun: this.auditRecord, funArg: '' }],
            0: []
          }
        } else {
          // 如果关闭H5审核，走旧逻辑
          creator = {
            1: [{ text: '备案意见', fun: this.showMaterialAuditRecord, funArg: '' }],
            '-1': [{ text: '备案意见', fun: this.showMaterialAuditRecord, funArg: '' }],
            0: []
          }
        }
        // 如果当前 登录人 是 创建人
        if (this.planInfo.createUserId == this.userInfo.userId) {
          // 判断当前用户角色： 1 超级管理员; 4 当地公司媒介; 5 全国媒介
          if (
            this.userInfo.userType === 1 ||
            this.userInfo.userType === 5 ||
            this.userInfo.userType === 4
          ) {
            // 如果开启H5审核
            if (this.isOpenH5Audit) {
              // 如果存在待审核记录（H5审核），显示 '撤回审批'
              if (this.isExistH5Audit) {
                creator['2'] = [
                  { text: '查看审批', fun: this.viewAudit, funArg: 'y' },
                  { text: '撤回审批', fun: this.recallAudit, funArg: 'y' },
                  { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
                ]
                creator['换画'] = [
                  { text: '查看审批', fun: this.viewAudit, funArg: 'y' },
                  { text: '撤回审批', fun: this.recallAudit, funArg: 'y' },
                  { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
                ]
              } else {
                // 如果不存在待审核记录（H5审核），显示 '发起审批'
                creator['2'] = [
                  { text: '发起审批', fun: this.createAudit, funArg: 'y' },
                  { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
                ]
                creator['换画'] = [
                  { text: '发起审批', fun: this.createAudit, funArg: 'y' },
                  { text: '审批记录', fun: this.auditRecord, funArg: 'n' }
                ]
              }
            } else {
              // 如果关闭H5审核，走旧逻辑
              creator['2'] = [
                { text: '备案通过', fun: this.handleMaterial, funArg: 'y' },
                { text: '备案拒绝', fun: this.handleMaterial, funArg: 'n' }
              ]
              creator['换画'] = [
                { text: '备案通过', fun: this.handleMaterial, funArg: 'y' },
                { text: '备案拒绝', fun: this.handleMaterial, funArg: 'n' }
              ]
            }
          }
          // 换画逻辑：订单投放中, 且 素材状态为 备案通过, 编辑了素材，没有审核的
          if (this.planInfo.status === 2 && this.materialStatus.status === 1 && this.needAudit) {
            return creator['换画'] || []
          } else {
            return creator[this.materialStatus.status] || []
          }
        }
        // 如果当前 登录人 不是 创建人
        else if (
          this.userInfo.userType === 1 ||
          this.userInfo.userType === 4 ||
          this.userInfo.userType === 5
        ) {
          // 换画逻辑：订单投放中, 且 素材状态为 备案通过, 编辑了素材，没有审核的
          if (this.planInfo.status === 2 && this.materialStatus.status === 1 && this.needAudit) {
            return reviewer['换画'] || []
          } else {
            return reviewer[this.materialStatus.status] || []
          }
        }
      }
      return []
    }
  },

  created() {},

  async mounted() {
    this.planId = sessionStorage.getItem('planId')
    await this.getAdPlanDetail()
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // 素材信息
    this.getMaterialInfo()
    // 资质信息
    this.getCertificationInfo()
    // 媒体列表
    this.getAllSendList()
    this.getPlanMachineCountInfo()
    // 处理素材审核
    await this.getH5AuditOpenStatus()
    if (this.isOpenH5Audit) await this.existNotAudit()
  },

  beforeDestroy() {
    //如果正在编辑（存在数据备份）
    this.cancelEditMaterial()
  },

  methods: {
    ...mapMutations(['setFramesData', 'setStorageFramesData']),

    /**
     * 获取h5审核开关状态
     */
    async getH5AuditOpenStatus() {
      try {
        const res = await materialApi.getH5AuditOpenStatus()
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.isOpenH5Audit = !!data
      } catch (err) {
        console.error('getH5AuditOpenStatus error:', err)
      }
    },

    /**
     * 校验是否存在待审核记录（H5审核）
     */
    async existNotAudit() {
      try {
        const res = await materialApi.existNotAudit({
          planId: this.planId
        })
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.isExistH5Audit = !!data
      } catch (err) {
        console.error('existNotAudit error:', err)
      }
    },

    /**
     * 发起审批
     */
    createAudit() {
      // 校验素材是否完整
      if (!this.verifyMateralFrames('createAudit')) return
      this.$confirm({
        title: '提示',
        content: '确定要发起审批吗？',
        onOk: async () => {
          try {
            const res = await materialApi.submitAudit({ planId: this.planId })
            const { code, msg, data } = res.data || {}
            if (code !== 200) return this.$message.error(msg)
            if (data) {
              this.$message.success('发起审批成功')
              this.isExistH5Audit = true
              this.$refs.materialAuditModalRef && this.$refs.materialAuditModalRef.open(this.planId)
            }
          } catch (err) {
            console.error('getAuditShareLink error:', err)
          }
        }
      })
    },

    /**
     * 撤回审批
     */
    recallAudit() {
      this.$confirm({
        title: '提示',
        content: '确定要撤回审批吗？',
        onOk: async () => {
          try {
            const res = await materialApi.revokeAudit({ planId: this.planId })
            const { code, msg, data } = res.data || {}
            if (code !== 200) return this.$message.error(msg)
            if (data) {
              this.$message.success('撤回审批成功')
              this.isExistH5Audit = false
            }
          } catch (err) {
            console.error('getAuditShareLink error:', err)
          }
        }
      })
    },

    /**
     * 查看审批
     */
    viewAudit() {
      this.$refs.materialAuditModalRef && this.$refs.materialAuditModalRef.open(this.planId)
    },

    /**
     * 审批记录
     */
    auditRecord() {
      this.$refs.materialAuditRecordModalRef &&
        this.$refs.materialAuditRecordModalRef.open(this.planId)
    },

    showFailModal(type) {
      this.failModalStatus = true
      this.$refs.failModal.getSendAdMachineInfoByPlanId(type)
    },
    isEndTime() {
      const endTime = new Date(
        moment(this.planInfo.endTime).format('YYYY-MM-DD') + ' 00:00:00'
      ).getTime()
      const toDay = new Date(moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00').getTime()
      return endTime == toDay
    },
    // 获取点位下发统计信息
    getPlanMachineCountInfo() {
      api.postApi('/adPlan/countPlanPointInfo?planId=' + this.planId).then(res => {
        if (res.data.code == 200) {
          const {
            data: { data }
          } = res
          this.planMachineCountInfo = data
          this.sumMedia = data.abnormalCount + data.offLineCount + data.onlineCount
        } else {
          this.$message.warning('获取点位统计信息失败,' + res.data.msg)
        }
      })
    },
    //获取机器列表
    getMachineArr() {
      api.getApi('/select/getModelInfo').then(res => {
        if (res.data.code == 200) {
          this.totalAreaColumns[0].filters = res.data.data.map(item => {
            return { text: item.deviceModelText, value: item.deviceModelText }
          })
        } else {
          this.$message.warning('获取设备型号失败,' + res.data.msg)
        }
      })
    },
    //获取计划详情
    async getAdPlanDetail() {
      return api.getApi('/adPlan/detail/' + this.planId).then(res => {
        if (res.data.code === 200 && res.data.data) {
          this.planInfo = res.data.data
          this.positionId = res.data.data.positionId
          this.materialSize = materialSize[this.positionId]

          this.getPlanMaterialType()
        } else {
          this.$message.error('获取计划失败！')
        }
      })
    },
    // 获取素材类型
    getPlanMaterialType() {
      api.postApi('/adPlan/getPlanMaterialType?planId=' + this.planId).then(res => {
        if (res.data.code === 200) {
          this.planInfo.materialType = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * 投放区域-查看全部
     *
     **/
    // 表头过滤 表头事件
    columnsFilter(pagination, filters, stor) {
      if (stor.field == 'onlineDayNum') {
        this.deviceFilterInfo.sortField = 'onlineDayNum'
        if (stor.order == 'ascend') {
          this.deviceFilterInfo.sortMode = 'asc'
        } else if (stor.order == 'descend') {
          this.deviceFilterInfo.sortMode = 'desc'
        } else {
          this.deviceFilterInfo.sortMode = null
        }
      }
      if (filters.modelType) this.deviceFilterInfo.deviceModel = filters.modelType.join(',')
      if (filters.communityName) this.deviceFilterInfo.communityName = filters.communityName[0]
      if (filters.companyName) this.deviceFilterInfo.companyName = filters.companyName[0]
      if (filters.deviceName) this.deviceFilterInfo.deviceName = filters.deviceName[0]
      if (filters.mac) this.deviceFilterInfo.mac = filters.mac[0]
      if (filters.deviceCode) this.deviceFilterInfo.deviceCode = filters.deviceCode[0]
      if (filters.canRelease) this.deviceFilterInfo.canRelease = filters.canRelease[0]
      if (filters.onlineStatus && filters.onlineStatus.length > 0) {
        this.deviceFilterInfo.onlineStatus = filters.onlineStatus[0] * 1
      }
      if (filters.watchMode) {
        this.deviceFilterInfo.watchMode = filters.watchMode.join(',') || null
      }
      this.getAllSendList()
    },
    // 获取投放区域详情列表
    showAllArea(data) {
      if (this.planInfo.status === 5 || this.planInfo.status === 2 || this.planInfo.status === 6) {
        this.getAllSendList(data || {})
        // this.getPlanMachineCountInfo()
      } else {
        this.getAllSendList(data || {})
      }
    },
    // 导出点位数据
    exportPoint() {
      let params = {
        planId: this.planId
      }
      let uri = '/adPlan/downloadAdMachineInfoByPlanId',
        blobType = 'application/vnd.ms-excel;charset=utf-8',
        suffix = `${this.planInfo.planName}_${this.sumMedia}_${moment(new Date()).format(
          'YYYYMMDD'
        )}.xls`
      api.getApi_file(uri, params).then(res => {
        let time = timeFormat.toDateTime(new Date(), '').split(' ')
        // let timeString = time[0] + time[1].split(':').join('');
        let blob = new Blob([res.data], { type: blobType })
        if (navigator.msSaveBlob) {
          // 启用IE内置下载器下载
          try {
            window.navigator.msSaveBlob(blob, suffix)
          } catch (e) {
            console.log(e)
          }
        } else {
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) //创建下载的链接
          downloadElement.href = href
          downloadElement.download = suffix //下载后文件名
          downloadElement.target = '_blank' // 针对 ie模式 的浏览器
          document.body.appendChild(downloadElement)
          downloadElement.click() //点击下载
          document.body.removeChild(downloadElement) //下载完成移除元素
          window.URL.revokeObjectURL(href) //释放掉blob对象
        }
      })
    },

    //获取设备下发列表（查看全部）type--> 1：订单状态为5|2|6  2：其他状态
    getAllSendList(filterParams) {
      if (filterParams) {
        this.deviceFilterInfo = {
          ...this.deviceFilterInfo,
          ...filterParams
        }
      }
      this.tableLoading = true
      let params = {
        planId: this.planId,
        pageNum: this.totalAreaPageInfo.current,
        pageSize: this.totalAreaPageInfo.pageSize,
        ...this.deviceFilterInfo
      }
      //更换表数据
      api
        .postApi('/adPlan/getPlanAdMachine', params)
        .then(res => {
          if (res.data.code === 200) {
            let arr = res.data.data.list.map((item, index) => {
              return {
                key: index,
                apId: item.apId,
                province: item.provinceName,
                city: item.cityName,
                area: item.areaName,
                deviceName: item.deviceName,
                modelType: item.deviceModelText,
                communityName: item.communityName || '--',
                areaString: item.areaName || '--',
                mediaString: item.doorName,
                status: item.devStatus,
                sendTime: item.sendTime || '--',
                publishScreenShotUrl: item.publishUrl || '--',
                devId: item.devId,
                mac: item.mac,
                downScreenShotUrl: item.downUrl || '--',
                deviceStatus: item.devStatus,
                onlineStatus: item.onlineStatus,
                clickPublishStatus: false,
                clickLowerStatus: false,
                pointId: item.id || '--',
                companyName: item.companyName || '--',
                deviceCode: item.id || '--',
                canRelease: item.canRelease,
                rejectReason: item.rejectReason || '--',
                onlineDayNum: item.onlineDayNum + '天',
                watchMode:
                  item.watchMode == ''
                    ? '--'
                    : item.watchMode == '1,2' || item.watchMode == '2,1'
                    ? '人工拍照/程序截屏'
                    : item.watchMode == '1'
                    ? '程序截屏'
                    : item.watchMode == '2'
                    ? '人工拍照'
                    : ''
              }
            })
            this.totalAreaList = arr
            this.totalAreaPageInfo.total = res.data.data.total
            this.isTotalAreaModal = true
            this.tableLoading = false
          } else {
            this.$message.warning(res.data.msg || '查看异常')
            this.tableLoading = false
          }
        })
        .catch(err => {
          this.tableLoading = false
        })
    },
    generateReport(status) {
      switch (Number(status)) {
        case 1:
          this.generateReportApi('/report/generatePublishReport?planId=', status)
          break
        case 2:
          this.generateReportApi('/report/generateDownReport?planId=', status)
          break
        case 3:
          this.generateReportApi('/report/generateReplaceReport?planId=', status)
          break
        default:
          break
      }
    },
    generateReportApi(url, status) {
      api
        .postApi_header(url + this.planId)
        .then(res => {
          const { code } = res.data
          if (code === 200) {
            this.generateReportArr.push(status)
            this.$message.success('请求成功！')
          } else {
            this.$message.error('截屏失败，请重试！')
          }
        })
        .catch(err => this.$message.error('截屏失败，请重试！'))
    },
    // 分页条数
    totalAreaChangeSize(current, pageSize) {
      this.totalAreaPageInfo.current = current
      this.totalAreaPageInfo.pageSize = pageSize
      this.getAllSendList()
    },
    // 页数
    totalAreaChangePage(page) {
      this.totalAreaPageInfo.current = page
      this.getAllSendList()
    },
    // 更换设备
    editPlanMedia() {
      this.editMediaClick = true
    },
    // 操作计划
    handlePlan(key) {
      let that = this,
        planId = that.planId,
        title = '',
        content = ''
      switch (key) {
        case 'acceptPlan':
          title = '确认要接受该订单吗？'
          // content = '终止后，该广告将不再曝光，是否确定终止？';
          break
        case 'rejectPlan':
          title = '确认要拒绝该订单吗？'
          // content = '终止后，该广告将不再曝光，是否确定终止？';
          break
        case 'cancelPlan':
          title = '确认要取消该订单吗？'
          // content = '终止后，该广告将不再曝光，是否确定终止？';
          break
        case 'pausePlan':
          // 暂停订单
          title = '确认要暂停该订单吗？'
          // content = '终止后，该广告将不再曝光，是否确定终止？';
          break
        case 'continuePlan':
          // 继续订单
          title = '确认要继续该订单吗？'
          // content = '终止后，该广告将不再曝光，是否确定终止？';
          break
        case 'stopPlan':
          // 终止订单
          title = '确认要终止该订单吗？'
          content = '终止后，该广告将不再曝光，是否确定终止？'
          break
        default:
          console.error('key:' + key + ' is not support now!')
          return
      }
      this.$confirm({
        title,
        content,
        onOk() {
          //确认终止
          api.postApi('/adPlan/' + key, { planId: planId }).then(res => {
            if (res.data.code === 200) {
              that.$message.success('操作成功')
              that.reload()
            } else {
              that.$message.error(res.data.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        }
        // class: 'test'
      })
    },
    // 获取计划拒绝理由
    getReason() {
      // 审核状态 0:接受,1:拒绝
      api.postApi('/adPlan/getPlanAuditRecord', { planId: this.planId, type: 1 }).then(res => {
        if (res.data.code === 200) {
          this.$warning({
            okText: '好的',
            title: '不通过（审批人：' + res.data.data.auditUserName + '）',
            content: res.data.data.remark || ''
          })
        }
      })
    },
    // 显示物料审核意见
    showMaterialAuditRecord() {
      if (!this.materialStatus.remark) {
        this.$message.warning('暂无备案意见！')
        return
      }
      console.log('this.materialStatus', this.materialStatus)
      if (this.materialStatus.status == 1) {
        this.$success({
          okText: '好的',
          title: this.materialStatus.statusName,
          content: this.materialStatus.remark || ''
        })
      } else if (this.materialStatus.status == -1) {
        this.$warning({
          okText: '好的',
          title: this.materialStatus.statusName,
          content: this.materialStatus.remark || ''
        })
      }
    },

    /**
     * 备案通过/备案拒绝
     */
    handleMaterial(type) {
      if (type === 'y') {
        this.isAuditPlan = false
        this.auditMaterialTitle = '备案意见'
      } else if (type === 'n') {
        this.isAuditPlan = false
        this.auditMaterialTitle = '拒绝意见'
      } else if (type === 'rejectPlan') {
        this.auditMaterialTitle = '请填写拒绝理由'
        this.isAuditPlan = true
      } else {
        return
      }
      this.auditMaterialModal = true
      this.auditMaterialType = type
    },
    //
    auditMaterial() {
      // 审核状态 0:接受,-1:拒绝
      if (this.isAuditPlan) {
        // 拒绝订单
        this.btnLoading = true
        api
          .postApi('/adPlan/rejectPlan', {
            planId: this.planId,
            remark: this.auditMaterialText
            // type: 0
          })
          .then(res => {
            if (res.data.code !== 200) {
              this.$message.warning(res.data.msg)
            } else {
              this.auditMaterialModal = false
              this.$message.success('操作成功')
              this.reload()
            }
          })
          .finally(res => {
            this.isAuditPlan = false
            this.auditMaterialText = ''
            this.btnLoading = false
          })
      } else {
        let info = {
            materialIds: this.materialStatus.materialIds,
            remark: this.auditMaterialText
          },
          uri = ''
        // 备案通过
        if (this.auditMaterialType === 'y') {
          info.status = 0
          uri = '/material/accept'
        } else {
          // 备案拒绝
          info.status = -1
          uri = '/material/reject'
        }
        //校验素材
        if (uri == '/material/accept') {
          if (!this.verifyMateralFrames('edit')) return
        }
        this.btnLoading = true
        api
          .postApi(uri, info)
          .then(res => {
            if (res.data.code !== 200) {
              this.$message.warning(res.data.msg)
            } else {
              this.auditMaterialModal = false
              // this.uploadMaterialModal = false
              this.$message.success('操作成功')
              this.reload()
            }
          })
          .finally(res => {
            this.auditMaterialText = ''
            this.btnLoading = false
          })
      }
    },
    //
    customOver() {
      this.imgHover = true
    },
    customLeave() {
      this.imgHover = false
    },
    // 下载图片
    downloadImg(url, name) {
      var _this = this
      var canvas = document.createElement('canvas')
      var img = document.createElement('img')

      img.onload = function(e) {
        canvas.width = img.width
        canvas.height = img.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        // canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob(blob => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = name
          link.click()
        }, 'image/png')
      }
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = url
    },
    // 当前展示图片
    setActiveQuaImg(url, index) {
      this.activeQuaImg = url
      this.activeQuaIndex = index
    },
    //预览大图/视频
    previewMaterial(type, url) {
      this.previewUrl = url
      if (type == 1) {
        this.previewImgModal = true
      } else {
        this.previewVideoModal = true
        let timer = setTimeout(() => {
          let video = this.$refs.showMaterialVideo
          video.play()
          clearTimeout(timer)
        }, 200)
      }
    },
    //编辑
    editPLan() {
      sessionStorage.setItem('planId', this.planId)
      sessionStorage.setItem('edit', 'edit')
      sessionStorage.setItem('planSetType', 'create')
      sessionStorage.setItem('targetSetType', 'create')
      sessionStorage.setItem('materialSetType', 'create')
      // sessionStorage.removeItem('selectedList')
      this.$localForage.removeItem('selectedList', () => {})
      sessionStorage.removeItem('materialDetailsList')
      sessionStorage.removeItem('formItem')
      sessionStorage.removeItem('modelInfoList')
      sessionStorage.removeItem('selectedInfo')
      sessionStorage.removeItem('areaDataListRow')
      sessionStorage.removeItem('framesData')
      this.$router.push('/channelPlanSet')
    },
    // 审核换画中的素材
    auditPlan(type) {
      if (type === 'y') {
        this.auditTitle = '备案意见'
      } else {
        this.auditTitle = '拒绝意见'
      }
      this.auditModal = true
      this.auditType = type
    },
    // 投放中计划审核需替换的物料素材
    pullPlanAuditMaterial() {
      // let newMaterial = this.newModelMaterial
      let params = {
        planId: this.planInfo.planId,
        remark: this.auditText
      }
      let url = ''
      if (this.auditType === 'y') {
        url = '/material/detail/passMaterialReplace'
      } else {
        url = '/material/detail/rejectMaterialReplace'
      }
      this.btnLoading = true
      api
        .postApi_www(url, params)
        .then(res => {
          if (res.data.code !== 200) {
            this.$message.warning(res.data.msg)
          } else {
            // 通过审核，替换物料素材
            this.$message.success('操作成功')
            this.reload()
          }
        })
        .finally(res => {
          this.btnLoading = false
        })
    },
    //关闭审核弹框
    clearValue() {
      this.auditText = ''
    },
    clearAuditMaterialText() {
      this.auditMaterialText = ''
    },
    // 放大关闭
    handleCancel() {
      this.previewVideoModal = false
      this.$refs.showMaterialVideo.pause()
    },
    // 获取资质信息
    getCertificationInfo() {
      let params = {
        planId: this.planId
      }
      api.getApiSpecil('/platform/certificationInfo/list', params).then(res => {
        if (res.data.code === 200) {
          this.certificationList = (res.data.data || []).map(_ => _.url)
          this.certificationList.length > 0 &&
            (this.activeQuaImg = this.certificationList[0]) &&
            (this.activeQuaIndex = 0)
        } else {
          this.$message.warn(res.data.msg || '资质信息获取异常')
        }
      })
    },
    // 获取素材列表
    getMaterialInfo() {
      let params = {
        planId: this.planId
      }
      let _this = this
      api.getApi('/material/list', params).then(res => {
        if (res.data.code === 200 && res.data.data && res.data.data.length > 0) {
          // 获取设备类型配置信息
          if (Array.isArray(res.data.data)) {
            _this.adMaterialList = res.data.data
            _this.materialStatus = {
              materialIds: res.data.data.map(item => item.materialId),
              status: res.data.data[0].status,
              remark: res.data.data[0].remark,
              statusName:
                { '-1': '备案不通过', 0: '无效', 1: '备案通过', 2: '待备案' }[
                  res.data.data[0].status
                ] || '异常'
            }
            //处理得到的数据并且存储到vuex中
            let info = this.setDateMaterialFormat(res.data.data[0])
            this.setFramesData(info)
            this.materialId = res.data.data[0].materialId
            this.needAudit = res.data.data[0].needAudit
          }
          // _this.getDeviceModel(res.data.data);
        } else {
          _this.$message.warn(res.data.msg || '素材信息获取异常')
        }
      })
    },
    //表格内搜索
    handleSearch(selectedKeys, confirm) {
      confirm()
    },
    handleReset(clearFilters) {
      clearFilters()
    },
    // 时常切换
    changeDuration(String) {
      for (let key of this.modelMaterials) {
        if (key.adSize === this.activeModelMaterial.adSize) {
          key.isDuration = this.activeModelMaterial.isDuration
          if (this.activeModelMaterial.fileType === 3 || String === 'del') {
            // 点击时长选项,如果上传的素材是视频则要清空重传
            this.clostFullImageUpdate()
          }
          break
        }
      }
    },
    // 删除图片、视频
    clostFullImageUpdate() {
      this.activeModelMaterial.fileUrl = ''
      this.activeModelMaterial.fileName = ''
      this.activeModelMaterial.fileId = ''
      this.activeModelMaterial.fileMd5 = ''
      this.activeModelMaterial.fileCryptUrl = ''
      this.activeModelMaterial.videoSnapshotUrl = ''
    },
    // 创建广告计划(第二步 保存素材信息和创建物料) planInfo.beginTime
    uploadMaterial() {
      this.uploadMLoading = true
      let details = []
      let temp = []
      for (let data of this.modelMaterials) {
        for (let i = 0; i < data.modelID.length; i++) {
          let obj = {
            ...data,
            model: data.model[i],
            modelID: data.modelID[i],
            materialId: data.materialId[i]
          }
          temp.push(obj)
        }
      }
      for (let key of temp) {
        let materialDetailsList = []
        if (key.fileId) {
          materialDetailsList = [
            {
              fileType: key.fileType, // 文件类型1为图片海报 2声音 3视频
              fileId: key.fileId,
              fileName: key.fileName,
              fileMd5: key.fileMd5,
              fileUrl: key.fileUrl,
              adSpace: key.adSpace, // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
              planId: this.planId,
              fileCryptUrl: key.fileCryptUrl,
              videoSnapshotUrl: key.videoSnapshotUrl
            }
          ]
        }
        details.push({
          materialId: key.materialId,
          planId: this.planId,
          playType: 1, // 全屏
          playDuration: key.isDuration,
          playTimes: this.planInfo.playTimes || 0,
          deviceModel: key.modelID,
          deviceModelText: key.model,
          beginTime: this.planInfo.beginTime,
          endTime: this.planInfo.endTime,
          materialDetailsList: materialDetailsList
        })
      }
      if (details.length) {
        let params = {
          planId: this.planId,
          materials: details
        }
        api
          .postApi('/material/detail/batch/save', params)
          .then(res => {
            if (res.data.code === 200) {
              this.$message.success('保存成功')
              this.uploadMaterialModal = false
              this.getAdPlanDetail()
              this.uploadMLoading = false
            } else {
              this.$message.warning(res.data.msg)
              this.uploadMLoading = false
            }
          })
          .catch(err => {
            console.log(err)
            this.uploadMLoading = false
          })
      } else {
        this.$message.warning('请上传素材')
      }
    },
    /**
     * 监播报告
     * */
    showReport() {
      //获取监播报告数据
      let info = {
        planId: this.planId,
        reportType: this.reportType,
        pageNum: this.reportPage
      }
      api.getApi('/report/list', info).then(res => {
        if (res.data.code == 200) {
          this.reportTotal = res.data.data.total
          this.reportList = res.data.data.list
        } else {
          this.$message.warning(res.data.mag)
        }
      })
      this.reportModel = true
    },
    changeReportPage(page, pageSize) {
      this.reportPage = page
      this.showReport()
    },
    //更新监播报告
    updateReport(item) {
      api.postApi('/report/update', { reportId: item.id }).then(res => {
        if (res.data.code == 200) {
          let time = timeFormat.toDateTime(new Date())
          item.updateTime = time.substring(0, time.lastIndexOf(':'))
          this.$message.success('更新成功')
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    //下载监播报告
    downloadReport(item) {
      if (item.url) {
        let downloadElement = document.createElement('a')
        let href = item.url
        let downloadName =
          item.updateTime + '-' + this.planInfo.planName + '-' + timeFormat.toDateTime2(new Date())
        downloadElement.href = href
        downloadElement.download = downloadName + '.pptx' //下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() //点击下载
        document.body.removeChild(downloadElement) //下载完成移除元素
        this.reportModel = false
        this.$success({
          title: '请在下载工具里查看文件',
          // JSX support
          content: '文件生成成功，正在下载'
        })
      } else {
        this.$message.warning('下载监播报告失败！')
      }
    },
    //切换广告素材 /资质材料
    onChangeMaterialRadioValue() {},
    //设置物料数据格式
    setDateMaterialFormat(date) {
      //将时间段处理成单个的时间
      date.adMaterialDetail.forEach(item => {
        let _playDates = []
        item.playDates &&
          item.playDates.forEach(i => {
            i = i.split('|')
            _playDates.push(...getDiffList(i[0], i[1], 'days'))
          })
        item.playDates = _playDates
      })
      // date.adMaterialDetail = array
      //添加审核状态
      date.planStatus = this.planInfo.status
      return date
    },
    handlerEditMaterial() {
      //存在待审核记录时，需撤回审批后才能编辑素材
      if (this.isExistH5Audit) {
        return this.$message.warning('请撤回审批后再操作编辑')
      }
      //编辑物料
      this.isEdit = true
      //编辑物料，本地缓存一份原始数据
      let date = {
        framesList: this.framesList,
        currentAdMaterialDetail: this.currentAdMaterialDetail,
        framesTagColor: this.framesTagColor,
        totalPlayDateNum: this.totalPlayDateNum,
        selectDateList: this.selectDateList,
        playDateNum: this.playDateNum,
        isUpload: this.isUpload
      }
      sessionStorage.setItem('framesDataCache', JSON.stringify(date))
    },
    //确定编辑
    completeEditMaterial() {
      //如果订单是投放中 修改物料使用接口不同
      let url, params
      if (this.planInfo.status == 2) {
        //是否发生修改，无修改则不能提交
        if (!this.isChange(true)) {
          return this.$message.warning('未有信息变更')
        }
        if (!this.verifyMateralFrames('edit')) return
        url = '/material/detail/saveReplace'
        params = this.getSaveReplaceParams()
      } else {
        //非投放中
        if (!this.isChange(false)) {
          return this.$message.warning('未有信息变更')
        }
        url = '/material/updateMultiAdMaterialDetail'
        params = this.getUpdateParams()
      }
      //判断订单是否是投放中
      api.postApi(url, params).then(res => {
        if (res.data.data && res.data.code == 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          sessionStorage.removeItem('framesDataCache')
        } else {
          this.$message.error(res.data.msg + '，保存失败')
          this.cancelEditMaterial()
        }
      })
    },
    //取消编辑
    cancelEditMaterial() {
      this.isEdit = false
      //确定和取消都删除原始数据
      //取消的话将原始数据同步到vuex
      try {
        let date = JSON.parse(sessionStorage.getItem('framesDataCache'))
        this.setStorageFramesData(date)
        sessionStorage.removeItem('framesDataCache')
      } catch (error) {}
    },
    //是否显示编辑物料按钮
    isShowEditMaterialBtn() {
      //1.不是编辑状态 2.在广告素材不是资质材料 3.是本人 4.订单状态支持修改
      if (
        !this.isEdit &&
        this.materialRadioValue == 1 &&
        this.planInfo.createUserId == this.userInfo.userId &&
        ![-999, -3, 6, 8, 9, 10].includes(this.planInfo.status)
      ) {
        return true
      }
      return false
    },
    //得到投放中修改物料的参数
    getSaveReplaceParams() {
      let params = []
      this.framesList.forEach((item, index) => {
        params.push({
          adSpace: item.adMaterialDetail.adSpace || 3,
          createTime: '',
          createUserId: JSON.parse(sessionStorage.userInfo).userId,
          detailsId: item.adMaterialDetail.id ? item.adMaterialDetail.id : null,
          fileCryptUrl: item.adMaterialDetail.fileCryptUrl,
          fileId: item.adMaterialDetail.fileId,
          fileMd5: item.adMaterialDetail.fullImageFileMd5,
          fileName: item.adMaterialDetail.fullImageName,
          fileType: item.adMaterialDetail.fileType,
          fileUrl: item.adMaterialDetail.fullImageUrl,
          materialId: this.materialId,
          materialInfo: item.adMaterialDetail.materialInfo,
          materialName: item.framesName,
          materialNumber: index + 1,
          planId: this.planId,
          playDates: getplayDates(item.playDates),
          tagColor: item.tagColor,
          updateTime: '',
          videoSnapshotUrl: item.adMaterialDetail.videoSnapshotUrl,
          isNew: item.adMaterialDetail.id ? false : true
        })
      })

      return params
    },
    //得到非投放中修改物料的参数
    getUpdateParams() {
      let adMaterialDetailList = this.getAdMaterialDetailList()
      let params = {
        adMaterialDetailList,
        materialIds: [this.materialId],
        planId: this.planId
      }
      return params
    },
    //得到非投放中修改物料的adMaterialDetailList参数
    getAdMaterialDetailList() {
      let adMaterialDetailList = []
      this.framesList.forEach((item, index) => {
        adMaterialDetailList.push({
          adSpace: item.adMaterialDetail.adSpace || 3,
          createTime: '',
          createUserId: JSON.parse(sessionStorage.userInfo).userId,
          fileCryptUrl: item.adMaterialDetail.fileCryptUrl,
          fileId: item.adMaterialDetail.fileId,
          fileMd5: item.adMaterialDetail.fullImageFileMd5,
          fileName: item.adMaterialDetail.fullImageName,
          fileType: item.adMaterialDetail.fileType,
          fileUrl: item.adMaterialDetail.fullImageUrl,
          materialInfo: item.adMaterialDetail.materialInfo,
          materialName: item.framesName,
          materialNumber: index + 1,
          planId: this.planId,
          playDates: getplayDates(item.playDates),
          status: 1,
          tagColor: item.tagColor,
          type: 0,
          updateTime: '',
          videoSnapshotUrl: item.adMaterialDetail.videoSnapshotUrl
        })
      })
      return adMaterialDetailList
    },
    //校验画面是否存在物料和日期以及日期是否全选
    verifyMateralFrames(type = 'audit') {
      //判断物料
      let isMateral = this.framesList.every(item => item.adMaterialDetail.fullImageUrl)
      if (!isMateral) {
        let message
        if (type == 'audit') {
          message = '当前有画面素材未上传,无法通过备案'
        } else if (type == 'edit') {
          message = '当前有画面素材未上传,无法完成编辑'
        } else if (type == 'createAudit') {
          message = '当前有画面素材未上传,无法发起审批'
        }
        this.$message.warning(message)
        return false
      }
      //判断是否都选择了日期
      // let isPlayDates = this.framesList.every(
      //   (item) => item.playDates.length > 0
      // )
      // if (!isPlayDates) {
      //   this.$message.warning('存在画面没有选择日期')
      //   return false
      // }
      //判断日期是否被选满
      if (this.playDateNum != this.totalPlayDateNum) {
        let message
        if (type == 'audit') {
          message = '当前有投放日期未设置画面,无法通过备案'
        } else if (type == 'edit') {
          message = '当前有投放日期未设置画面,无法完成编辑'
        } else if (type == 'createAudit') {
          message = '当前有投放日期未设置画面,无法发起审批'
        }
        this.$message.warning(message)
        return false
      }
      return true
    },
    //订单编辑是否发生修改
    isChange(isPlay) {
      //投放中订单的画面不能删除不能修改 所以判断有没有发生改变。只要判断数量一致和选择的日期一致就行了
      //拿出编辑前备份的数据
      let framesDataCache = JSON.parse(sessionStorage.getItem('framesDataCache'))
      //判断数量是否变化
      if (framesDataCache.framesList.length != this.framesList.length) return true

      //判断选择的日期数量有没有发生改变
      if (framesDataCache.selectDateList.length != this.selectDateList.length) return true

      //判断选择的日期是不是跟之前的一致
      if (this.diffFrames(framesDataCache.framesList, this.framesList, isPlay)) return true

      return false
    },
    //比较diffFrames 比较投放日期
    diffFrames(oldValue, newValue, isPlay) {
      for (let i = 0; i < oldValue.length; i++) {
        let oldPlayDates = oldValue[i].playDates
        let newPlayDates = newValue[i].playDates
        //长度不同，直接返回改变
        if (oldPlayDates.length != newPlayDates.length) return true
        //新数组不包括旧数组数据直接返回改变
        if (!this.diffPlayDates(oldPlayDates, newPlayDates)) return true
        //投放中订单的画面默认锁定不比较素材；
        //但待审核(auditStatus=0)且不存在审批中记录的画面允许更换素材，需把素材变化纳入变更判断，否则提交会被“未有信息变更”拦截
        //删除素材后新数据的 adMaterialDetail 会被清空，auditStatus 需同时看编辑前的旧值
        let oldAuditStatus = (oldValue[i].adMaterialDetail || {}).auditStatus
        let newAuditStatus = (newValue[i].adMaterialDetail || {}).auditStatus
        let materialEditable =
          !isPlay ||
          ((oldAuditStatus === 0 || newAuditStatus === 0) && !this.isExistH5Audit)
        if (materialEditable) {
          //长度在isNoPlayChange已经验证
          if (!this.diffFramesName(oldValue[i], newValue[i])) return true
          if (!this.diffFullImageFileUrl(oldValue[i], newValue[i])) return true
        }
      }
      return false
    },
    //比较两个数组是否相同
    diffPlayDates(oldValue, newValue) {
      return newValue.every(element => {
        return oldValue.includes(element)
      })
    },
    //比较画面名称有没有变化
    diffFramesName(oldValue, newValue) {
      return oldValue.framesName == newValue.framesName
    },
    //比较素材url有没有变化 因为素材重新上传的话url会发生改变
    diffFullImageFileUrl(oldValue, newValue) {
      return (
        oldValue.adMaterialDetail.fullImageFileUrl == newValue.adMaterialDetail.fullImageFileUrl
      )
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-filters {
  padding-left: 16px;
}
/deep/ .ant-table-tbody > tr > td {
  padding-left: 16px;
  height: 54px;
}
/deep/ .row-label {
  color: rgba(0, 0, 0, 0.85);
}
/deep/.ant-table-thead > tr > th {
  padding-left: 16px;
  height: 54px;
}
.plan-detail-table {
  background: white;
  margin: 0 24px;
  padding: 32px;
  padding-top: 24px;
  border-radius: 0 0 2px 2px;
  .import_excel {
    position: absolute;
    right: 16px;
    cursor: pointer;
  }
  .explain-modal {
    position: absolute;
    right: 96px;
    cursor: pointer;
  }
}
.plan-detail-title {
  height: 55px;
  background: #fff;
  margin: 0px 24px;
  margin-top: 8px;
  font-size: 16px;
  font-family: 'PingFangSC-Medium, PingFang SC';
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  display: flex;
  padding-left: 32px;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(233, 233, 233, 1);
  border-radius: 2px 2px 0 0;
}

.ant-upload > div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.preview-img /deep/ .ant-modal-content,
.preview-video /deep/ .ant-modal-content {
  background: rgba(0, 0, 0, 0);
  box-shadow: unset;
}

.img-box,
.video-box {
  text-align: center;
}

.img-box img {
  width: auto;
  height: 600px;
  object-fit: contain;
}

.video-box video {
  width: auto;
  height: 600px;
}
/deep/ .ant-tabs-nav-scroll {
  background: white;
  padding-left: 30px;
}
/deep/ .echarts_tooltip_title {
  width: 200px;
  height: 36px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: -20px;
  color: #808080;
  background-color: #f4f6f6;
  font-size: 12px;
}

/deep/ .echarts_tooltip_content {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  align-items: center;
  font-size: 12px;
  color: #2c313c;
  height: 32px;
  line-height: 32px;
}

/deep/ .echarts_tooltip_i {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 5px;
}
/*详情*/
.info-panel {
  position: relative;
  margin: 8px 24px 0;
  border-radius: 2px;
  background: #fff;
  .panel-header {
    width: 100%;
    padding: 16px 32px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    border-bottom: 1px solid #e9e9e9;
  }
  .panel-body {
    padding: 24px 32px;
    .switch_btn_wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;
    }
    .alert_class {
      width: 913px;
      margin: 0 auto 16px;
    }
    .content_warpper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .edit_btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 180px;
      }
    }
    .panel-body-name {
      display: block;
      margin: 0 0 16px 0;
      font-size: 20px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
    }
    .grow-view {
      flex-grow: 1;
      margin-bottom: 24px;
    }
    .content-bar {
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      box-sizing: border-box;
      border-bottom: 1px solid #e9e9e9;
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      background: #fafafa;
    }
    .body-left {
      min-width: 616px;
      height: 620px;
      box-sizing: border-box;
      border: 1px solid #e9e9e9;
    }
    .body-right {
      width: 437px;
      height: 620px;
      box-sizing: border-box;
      border: 1px solid #e9e9e9;
    }
    .panel-info-item {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      em {
        color: rgba(0, 0, 0, 0.85);
      }
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .panel-order-status {
      text-align: end;
      dd {
        .margin-top {
          margin-bottom: 4px;
        }
        /deep/ .ant-badge-status-dot {
          width: 12px;
          height: 12px;
        }
        /deep/ .ant-badge-status-text {
          font-size: 20px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
        }
      }
    }
  }
  .panel-footer {
    margin-top: 8px;
    padding: 0 0 32px;
  }
}
/*投放效果报告*/
.info-box-a {
  text-decoration: underline !important;
  padding-left: 5px;
  padding-right: 5px;
  color: #ff6925;
}
.results_statistical {
  margin: 8px 24px 24px;
  background: #fff;

  .table_box {
    padding: 24px;

    .info_box {
      height: 32px;
      background: rgba(230, 247, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(145, 213, 255, 1);
      line-height: 32px;
      padding: 0 16px;
      position: relative;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 16px;

      > i {
        color: #fff;
        background: rgba(24, 144, 255, 1);
        border-radius: 50%;
      }

      span {
        color: rgba(24, 144, 255, 1);
      }

      .import_excel {
        position: absolute;
        right: 16px;
        cursor: pointer;
      }
    }
  }
  .page-wrap {
    float: unset;
    text-align: right;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
}

/*上传物料*/
.material_warp {
  width: 100%;
  height: calc(100% - 48px);
  margin: 0 auto;
  display: flex;

  .left_tags {
    width: 288px;
    padding: 8px;
    border-right: 1px solid rgba(233, 233, 233, 1);
    overflow-y: auto;

    li {
      border-radius: 4px;
      padding: 12px;
      cursor: pointer;
      margin-bottom: 8px;
      position: relative;

      h4 {
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
      }

      .active_icon {
        position: absolute;
        right: 12px;
        top: 27px;

        svg {
          font-size: 18px;
          color: rgba(82, 196, 26, 1);
        }
      }
      p {
        display: inline-block;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding: 0 8px;
        color: rgba(0, 0, 0, 0.65);
        margin-right: 8px;
        margin-top: 8px;
      }
      p:last-child {
        margin-right: 0;
      }

      span.active_icon {
        display: inline-block;
        width: 56px;
        height: 26px;
        line-height: 26px;
        background: rgba(250, 173, 20, 1);
        border-radius: 17px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        top: 20px;
      }

      .pulling_audit {
        margin-top: 8px;

        button:nth-last-child(1) {
          margin-left: 8px;
        }
      }
    }
    .active_tag {
      background: rgba(0, 0, 0, 0.05);
    }
  }

  .right_conten {
    flex: 1;
    position: relative;

    header {
      height: 64px;
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      line-height: 64px;
      text-align: center;

      .ant-form-item {
        margin-bottom: 0;
        height: 100%;

        .ant-form-item-label,
        .ant-form-item-control {
          line-height: 64px;
        }
      }
    }

    .icon_btn {
      position: absolute;
      right: 36px;
      bottom: 36px;
      width: 50px;
      z-index: 99;
      .icon_wrap {
        display: inline-block;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-bottom: 16px;
        cursor: pointer;
        line-height: 48px;
        text-align: center;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);

        .anticon {
          svg {
            font-size: 21px;
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }

      .icon_wrap:hover {
        border-color: rgba(23, 144, 255, 1);

        svg {
          color: rgba(23, 144, 255, 1);
        }
      }
      .disable_icon_wrap {
        cursor: not-allowed;
        background: rgba(241, 241, 241, 1);
        border: 2px solid rgba(0, 0, 0, 0.2);

        & :hover {
          border: 2px solid rgba(0, 0, 0, 0.2);

          svg {
            color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }

    .content_main {
      display: flex;
      justify-content: center;
      padding: 40px 0 0;
      .content_warp {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .m-bg-img {
        cursor: pointer;
        position: relative;
        img {
          width: 280px;
          height: 400px;
          object-fit: contain;
        }
        video {
          width: 280px;
          height: 400px;
          object-fit: contain;
        }
        span {
          width: 126px;
          height: 32px;
          line-height: 32px;
          border-radius: 17px;
          display: block;
          background: rgba(239, 239, 239, 1);
          margin: 12px auto 16px;
          text-align: center;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          position: absolute;
          bottom: -68px;
          left: 50%;
          transform: translateX(-50%);
        }
        .span_new {
          background: rgba(24, 144, 255, 0.15);
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}

/*资质*/
.qualification_warp {
  display: flex;
  height: calc(100% - 48px);
  .thumbnail-list {
    width: 113px;
    height: 100%;
    padding: 16px 0;
    padding-top: -10px;
    padding-bottom: -10px;
    text-align: center;
    overflow-y: auto;
    box-sizing: border-box;
    border-right: 1px solid #e9e9e9;
    .thumbnail-item {
      width: 80px;
      height: 80px;
      margin-top: 6px;
      margin-bottom: 6px;
      object-fit: contain;
      cursor: pointer;
      &:hover,
      &:active {
        border: 1px solid #1890ff;
      }
      &.active-border {
        border: 1px solid #1890ff;
      }
    }
  }
  .qualification-info {
    width: 100%;
    header {
      height: 64px;
      border-bottom: 1px solid rgba(233, 233, 233, 1);
      line-height: 64px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
    }
    .qualification-wrap {
      display: flex;
      justify-content: center;
      padding: 40px 0 0;
    }
    .img-hover {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .img-hover-bg {
      background: rgba(0, 0, 0, 0.3);
    }
    .qualification-item {
      width: 300px;
      height: 400px;
      object-fit: contain;
      cursor: pointer;
    }
  }
}

/*投放中计划 投放区域-查看全部*/

.totalArea_header {
  .info_box {
    height: 32px;
    background: rgba(230, 247, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(145, 213, 255, 1);
    line-height: 32px;
    padding: 0 16px;
    position: relative;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 16px;

    > i {
      color: #fff;
      background: rgba(24, 144, 255, 1);
      border-radius: 50%;
    }

    span {
      color: rgba(24, 144, 255, 1);
    }
  }
  /deep/ .ant-row {
    margin-bottom: 16px;

    .ant-input {
      width: 80%;
    }
  }
}
.totalArea_table {
  max-height: 595px;
  min-height: 320px;
  overflow-y: auto;

  .show_img_btn {
    cursor: pointer;
    color: #1890ff;
  }

  .not_have_img {
    color: rgba(0, 0, 0, 0.25);
    cursor: unset;
  }

  .ant-badge-not-a-wrapper {
    vertical-align: unset;
  }
  /deep/ .ant-table-body,
  /deep/ .ant-table-tbody,
  /deep/ .ant-table-thead {
    td,
    th {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 16px 8px;
    }
  }
}
</style>
<style lang="scss">
/*监播报告*/
.report-model {
  .ant-modal-body {
    text-align: center;
    padding: 16px 24px 32px;
  }
  .cards-wrap {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    .card {
      width: 272px;
      height: 129px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(232, 232, 232, 1);
      border-bottom: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 25px;
      margin-bottom: 25px;
      overflow: hidden;
      .card-top {
        padding: 12px;
        box-sizing: border-box;
        .card-img {
          width: 64px;
          height: 64px;
          background: rgba(216, 216, 216, 1);
          border-radius: 4px;
          margin-right: 16px;
          float: left;
        }
        .card-time,
        .card-count {
          float: left;
        }
        .card-time {
          color: rgba(0, 0, 0, 0.85);
          div {
            display: inline-block;
            span {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.45);
              transform: scale(0.83);
              display: inline-block;
            }
            width: 32px;
            height: 16px;
            line-height: 16px;
            background: rgba(0, 0, 0, 0.06);
            border-radius: 2px;
            text-align: center;
          }
        }
        .card-count {
          span {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
          }
          span:nth-child(2) {
            margin: 0 8px;
            color: #e8e8e8;
          }
        }
      }
      .card-bottom {
        display: flex;
        height: 40px;
        background: rgba(247, 249, 250, 1);
        border-radius: 0px 0px 2px 2px;
        padding: 12px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e8e8e8;
        div {
          flex: 1;
          cursor: pointer;
          text-align: center;
          border-right: 1px solid #e8e8e8;
        }
        div:last-child {
          border-right: none;
        }
        .anticon {
          color: rgba(0, 0, 0, 0.45);
        }
        div:hover,
        div:hover .anticon {
          color: #1890ff;
        }
      }
    }
    .card:last-child,
    .card:nth-child(3n) {
      margin-right: 0;
    }
  }
  .report-page {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .ant-modal-close-x {
    line-height: 55px;
  }
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 0;
  padding-top: 12px;
  padding-bottom: 13px;
  font-size: 14px;
  font-family: 'PingFangSC-Medium, PingFang SC';
  color: rgba(0, 0, 0, 0.85);
  line-height: 21px;
  text-align: center;
}
.advertiserName {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
